import React from 'react'
import Sidebar from "./sidebar";
import Navbar from './navbar';
import useAuth from "./useAuth";
import { Link, useNavigate } from "react-router-dom";

const Pas_acces = () => {
  const user_id = localStorage.getItem("userId");

  return (
        <div id="wrapper">
          <Sidebar user_id={user_id} />
          <div id="page-wrapper" className="gray-bg">
            <Navbar />
            <div className="wrapper wrapper-content animated fadeInRight">
              <div className="row">
                <div className="col-lg-12">
                  <div className="ibox">
                    <div className="ibox-content text-center p-5">
                      <div className="mb-4">
                        <i className="fa fa-lock fa-5x text-warning"></i>
                      </div>
                      <h2>Accès restreint</h2>
                      <p className="lead mb-4">
                        Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                      </p>
                      <div className="d-flex justify-content-center">
                        <Link to="/" className="btn btn-primary">
                          <i className="fa fa-arrow-left mr-2"></i>
                          Retour
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
  )
}

export default Pas_acces